// extracted by mini-css-extract-plugin
export default {"column":"hqxkISXOYqDMTgLjmHMV","backbutton":"fcM6UNv8xdM8VD8jEkxN","pulse":"mH1zNGLeWxsny62NiViF"};